import { render, staticRenderFns } from "./ShopShowItem.vue?vue&type=template&id=e4c873d4&scoped=true&"
import script from "./ShopShowItem.vue?vue&type=script&lang=js&"
export * from "./ShopShowItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c873d4",
  null
  
)

export default component.exports